<div style="margin-left: 80%; margin-bottom: 2%;">
    <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; " mat-raised-button color="primary"
    printSectionId="print-section" [useExistingCss]="true" ngxPrint>
  Print
  </button> 

  <button (click)="printPage()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
Print
</button>
    <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Advt_Invoice_Register')"
        mat-raised-button color="primary">
        Export
    </button>
    <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
        Close
    </button>
</div>  

<ng-container *ngIf="reportType == 'Indetail-Officer'">
  <div class="container" id="print-section" style="margin-top:50px; margin-right: 3px; margin-left: 3px;">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="13" style="font-size: medium;">
            हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - जाहिरात विभाग - Advt Invoice Register
          </th>
          <th colspan="2" style="font-size: medium;">InDetail Officer</th>
          <th colspan="5" style="font-size: medium;">दिनांक - {{ today | date:"dd-MM-yyy" }}</th>
          <th colspan="3" style="font-size: medium;">पृष्ठ क्र.- 1</th>
        </tr>
        <tr>
          <th colspan="8" class="leftAlign"></th>
          <th colspan="6" class="leftAlign"><div>Issue Date :</div></th>
          <th colspan="9" class="leftAlign" style="font-size: medium;">
            <div>Date : From : {{ startDate | date:"dd-MM-yyy" }} To : {{ endDate | date:"dd-MM-yyy" }}</div>
          </th>
        </tr>
        <tr>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Invoice No.</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Invoice<br>Date</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Advertiser Name</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Customer <br>Name</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Issue Name</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Issue Date</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Representative <br>Name</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Office <br> Rep<br> Name</th>
          <th colspan="5" style="font-size: 14px !important; text-align: center;">Weekly Issue <br> Date</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Advt. <br> Amount</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Discount <br>Amount</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Amount<br>before GST</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">CGST</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">SGST</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">IGST</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Total GST</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Total Invoice <br> Amount</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Paid <br> Amount</th>
          <th rowspan="2" style="font-size: 14px !important; text-align: center;">Unpaid<br>Amount</th>
        </tr>
        <tr>
          <th>1st Week</th>
          <th>2nd Week</th>
          <th>3rd Week</th>
          <th>4th Week</th>
          <th>5th Week</th>
        </tr>
      </thead>

      <tbody>
        <!-- Group by Office Representative -->
       <ng-container *ngFor="let officeGroup of filteredAdvtInvoiceData">
  <!-- Office Representative Header -->
  <tr>
    <td colspan="23" style="font-weight:bold; font-size:16px; background:#97daee; text-align:left;">
      Office Representative : {{ officeGroup.off_rep_name }}
    </td>
  </tr>

  <!-- Loop through Representatives under this Office Representative -->
  <ng-container *ngFor="let repGroup of officeGroup.representatives">
    <!-- Representative Header -->
    <tr>
      <td colspan="23" style="font-weight:bold; font-size:14px; background:#8496e7; padding-left:25px; text-align:left;">
        Representative : {{ repGroup.rep_name }}
      </td>
    </tr>

    <!-- Invoice rows for this Representative -->
    <ng-container *ngFor="let data of repGroup.data">
      <tr>
        <td>{{ data['invoice_no'] }}</td>
        <td>{{ data['invoice_date'] }}</td>
        <td style="font-weight:bold">{{ data['advt_name'] | slice:0:30 }}</td>
        <td>{{ data['cust_name'] }}</td>
        <td>{{ data['combined_issue_name']  | slice:0:20}}</td>
        <td>{{ data['combined_issue_date']  | slice:0:20}}</td>
        <td>{{ data['rep_name'] }}</td>
        <td>{{ data['off_rep_name'] }}</td>

        <td style="text-align:end;">
          <ng-container *ngIf="data['first_week_amount'] != '0' && data['first_week_amount'] != 0; else week1">{{ data['first_week_amount'] }}</ng-container>
          <ng-template #week1>0</ng-template>
        </td>
        <td style="text-align:end;">
          <ng-container *ngIf="data['second_week_amount'] != '0' && data['second_week_amount'] != 0; else week2">{{ data['second_week_amount'] }}</ng-container>
          <ng-template #week2>0</ng-template>
        </td>
        <td style="text-align:end;">
          <ng-container *ngIf="data['third_week_amount'] != '0' && data['third_week_amount'] != 0; else week3">{{ data['third_week_amount'] }}</ng-container>
          <ng-template #week3>0</ng-template>
        </td>
        <td style="text-align:end;">
          <ng-container *ngIf="data['fourth_week_amount'] != '0' && data['fourth_week_amount'] != 0; else week4">{{ data['fourth_week_amount'] }}</ng-container>
          <ng-template #week4>0</ng-template>
        </td>
        <td style="text-align:end;">
          <ng-container *ngIf="data['fifth_week_amount'] != '0' && data['fifth_week_amount'] != 0; else week5">{{ data['fifth_week_amount'] }}</ng-container>
          <ng-template #week5>0</ng-template>
        </td>

        <td style="text-align:end;"><span>{{ data['advt_amt'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['discount'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['beforegst_amt'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['cgst'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['sgst'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['igst'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['gst'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['invoice_total'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['received_amt'] }}</span></td>
        <td style="text-align:end;"><span>{{ data['unpaid_amount'] }}</span></td>
      </tr>
    </ng-container>

    <!-- Representative-wise Total Row -->
    <tr style="background:#e8f4f8;">
      <td style="font-weight: bold; border: 1px solid #000;" colspan="8">Representative Total ({{ repGroup.rep_name }})</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;"></td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;"></td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;"></td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;"></td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;"></td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_advt_amt }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_discount }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_beforegst_amt }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_cgst }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_sgst }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_igst }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_gst }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_invoice_total }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_paid_amt }}</td>
      <td style="text-align:end; font-weight:bold; border:1px solid #000;font-size: 14px;">{{ repGroup.rep_unpaid_amt }}</td>
    </tr>
  </ng-container>

  <!-- Office Representative Total Row (after all representatives) -->
  <tr style="background:#d4edff;">
    <td style="font-weight: bold; border: 2px solid #000;" colspan="8">Office Representative Total ({{ officeGroup.off_rep_name }})</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;"></td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;"></td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;"></td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;"></td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;"></td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_advt_amt }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_discount }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_beforegst_amt }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_cgst }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_sgst }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_igst }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_gst }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_invoice_total }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_paid_amt }}</td>
    <td style="text-align:end; font-weight:bold; border:2px solid #000;font-size: 15px;">{{ officeGroup.office_unpaid_amt }}</td>
  </tr>
</ng-container>
      </tbody>

      <!-- Grand Totals row -->
      <tr>
        <td style="font-weight: bold; border: 1px solid #000;" colspan="13">Total</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{advtamount}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{discountamt}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{totalbeforegstamount}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{cgst}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{sgst}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{igst}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{gstcst}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{invoice_total}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">{{paidamount}}</td>
        <td style="text-align:end;font-size: medium; font-weight:bold; border:1px solid #000;">
          {{ (invoice_total - paidamount * 1).toFixed(2) }}
        </td>
      </tr>
    </table>
  </div>
</ng-container>